(function (root) {
  "use strict";

  var OA_VERSION = "1";
  var STORAGE_KEY = "oa_attribution_state_v1";
  var DEFAULTS = {
    debug: false,
    attributionWindowDays: 30,
    sessionTimeoutMinutes: 30,
    maxPaidJourneyTouches: 20,
    extraInternalHosts: []
  };
  var PARAMS = [
    "oa_source", "oa_campaign_id", "oa_adset_id", "oa_ad_id", "oa_placement",
    "placement", "Placement", "utm_placement",
    "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "utm_adset", "utm_ad",
    "fbclid", "gclid", "ttclid"
  ];
  var META_SOURCES = { facebook: true, fb: true, instagram: true, ig: true, meta: true, an: true, msg: true, messenger: true };
  var PAID_MEDIUMS = { paid: true, cpc: true, ppc: true, paid_social: true, paidsocial: true, social_paid: true, paid_search: true };
  var SEARCH_HINTS = ["google", "bing", "duckduckgo", "yahoo", "ecosia"];
  var memoryTouch = null;

  function cfg() {
    var custom = root.OA_ATTRIBUTION_CONFIG || {};
    return {
      debug: Boolean(custom.debug || DEFAULTS.debug),
      attributionWindowDays: Number(custom.attributionWindowDays || DEFAULTS.attributionWindowDays),
      sessionTimeoutMinutes: Number(custom.sessionTimeoutMinutes || DEFAULTS.sessionTimeoutMinutes),
      maxPaidJourneyTouches: Number(custom.maxPaidJourneyTouches || DEFAULTS.maxPaidJourneyTouches),
      extraInternalHosts: custom.extraInternalHosts || DEFAULTS.extraInternalHosts
    };
  }

  function log() {
    if (!cfg().debug || !root.console) return;
    var args = Array.prototype.slice.call(arguments);
    args.unshift("[OA]");
    root.console.log.apply(root.console, args);
  }

  function nowIso(now) {
    return (now instanceof Date ? now : new Date()).toISOString();
  }

  function normalize(value) {
    return String(value || "").trim().toLowerCase().replace(/\s+/g, "_");
  }

  function normalizeHost(host) {
    var value = normalize(host).replace(/^www\./, "");
    return value;
  }

  function parseAllowedParams(url) {
    var base = root.location ? root.location.origin : "https://example.com";
    var parsed = new URL(url, base);
    var out = {};
    PARAMS.forEach(function (key) {
      var value = parsed.searchParams.get(key);
      if (value) out[key] = value.substring(0, 500);
    });
    return out;
  }

  function hasAdvertisingParams(params) {
    return Boolean(params.oa_source || params.oa_campaign_id || params.oa_adset_id || params.oa_ad_id || params.fbclid || params.gclid || params.ttclid || params.utm_source || params.utm_medium);
  }

  function referrerHost(referrer) {
    if (!referrer) return "";
    try { return normalizeHost(new URL(referrer).hostname); } catch (_err) { return ""; }
  }

  function isInternalReferrer(refHost, currentHost, extraHosts) {
    var ref = normalizeHost(refHost);
    var current = normalizeHost(currentHost);
    if (!ref || !current) return false;
    var hosts = [current].concat(extraHosts || []);
    for (var i = 0; i < hosts.length; i += 1) {
      var host = normalizeHost(hosts[i]);
      if (ref === host || ref.endsWith("." + host)) return true;
    }
    return false;
  }

  function classify(params, refHost) {
    var source = normalize(params.oa_source || params.utm_source);
    var medium = normalize(params.utm_medium);
    var ref = normalizeHost(refHost);
    if (params.oa_ad_id || params.fbclid || META_SOURCES[source]) {
      return { source: source || "meta", medium: medium || "paid_social", classification: "meta_paid", paid: true };
    }
    if (params.gclid || (source === "google" && PAID_MEDIUMS[medium])) {
      return { source: source || "google", medium: medium || "cpc", classification: "google_paid", paid: true };
    }
    if (params.ttclid || source === "tiktok") {
      return { source: source || "tiktok", medium: medium || "paid_social", classification: "tiktok_paid", paid: true };
    }
    if (medium === "email" || source === "email" || source === "newsletter" || source === "klaviyo") {
      return { source: source || "email", medium: medium || "email", classification: "email", paid: false };
    }
    if (source) {
      return { source: source, medium: medium || "referral", classification: PAID_MEDIUMS[medium] ? "paid_other" : "unknown", paid: Boolean(PAID_MEDIUMS[medium]) };
    }
    for (var i = 0; i < SEARCH_HINTS.length; i += 1) {
      if (ref.indexOf(SEARCH_HINTS[i]) !== -1) {
        return { source: SEARCH_HINTS[i], medium: "organic", classification: SEARCH_HINTS[i] + "_organic", paid: false };
      }
    }
    if (ref) return { source: ref, medium: "referral", classification: "referral", paid: false };
    return { source: "direct", medium: "direct", classification: "direct", paid: false };
  }

  function buildTouch(url, referrer, currentHost, now) {
    var parsed = new URL(url, root.location ? root.location.origin : "https://example.com");
    var params = parseAllowedParams(url);
    var refHost = referrerHost(referrer);
    if (isInternalReferrer(refHost, currentHost, cfg().extraInternalHosts)) refHost = "";
    var classified = classify(params, refHost);
    var clickId = params.fbclid || params.gclid || params.ttclid || "";
    var clickType = params.fbclid ? "fbclid" : params.gclid ? "gclid" : params.ttclid ? "ttclid" : "";
    return {
      source: classified.source,
      medium: classified.medium,
      campaign_id: String(params.oa_campaign_id || params.utm_campaign || ""),
      adset_id: String(params.oa_adset_id || params.utm_adset || params.utm_medium || ""),
      ad_id: String(params.oa_ad_id || params.utm_ad || params.utm_content || ""),
      placement: String(params.oa_placement || params.placement || params.Placement || params.utm_placement || ""),
      click_id: String(clickId),
      click_id_type: clickType,
      ts: nowIso(now),
      landing_path: parsed.pathname || "/",
      referrer_host: refHost,
      classification: classified.classification
    };
  }

  function isPaid(touch) {
    return Boolean(touch && (touch.classification || "").indexOf("_paid") !== -1);
  }

  function touchKey(touch) {
    if (!touch) return "";
    return [touch.source, touch.medium, touch.campaign_id, touch.adset_id, touch.ad_id, touch.placement, touch.referrer_host, touch.classification].join("|");
  }

  function compactJourneyTouch(touch) {
    return {
      source: compact(touch.source),
      medium: compact(touch.medium),
      campaign_id: compact(touch.campaign_id),
      adset_id: compact(touch.adset_id),
      ad_id: compact(touch.ad_id),
      placement: compact(touch.placement),
      click_id: compact(touch.click_id),
      click_id_type: compact(touch.click_id_type),
      ts: compact(touch.ts),
      landing_path: compact(touch.landing_path),
      referrer_host: compact(touch.referrer_host),
      classification: compact(touch.classification)
    };
  }

  function normalizePaidJourney(journey, now, options) {
    var seen = {};
    var items = (journey || []).filter(function (touch) {
      if (!touch || !isPaid(touch) || expired(touch.ts, now, options.attributionWindowDays)) return false;
      var key = touchKey(touch) + "|" + touch.ts;
      if (seen[key]) return false;
      seen[key] = true;
      return true;
    });
    return items.slice(Math.max(0, items.length - options.maxPaidJourneyTouches));
  }

  function bootstrapPaidJourney(state, now, options) {
    var items = normalizePaidJourney(state.paid_journey, now, options);
    if (!items.length && state.first_paid) items.push(compactJourneyTouch(state.first_paid));
    if (state.last_paid && touchKey(state.last_paid) !== touchKey(items[items.length - 1])) {
      items.push(compactJourneyTouch(state.last_paid));
    }
    return normalizePaidJourney(items, now, options);
  }

  function serializePaidJourney(journey) {
    var items = (journey || []).map(compactJourneyTouch);
    var json = JSON.stringify(items);
    while (json.length > 10000 && items.length > 1) {
      items.shift();
      json = JSON.stringify(items);
    }
    return json.length <= 10000 ? json : "";
  }

  function expired(ts, now, windowDays) {
    if (!ts) return true;
    var t = Date.parse(ts);
    if (!isFinite(t)) return true;
    return (now.getTime() - t) > windowDays * 24 * 60 * 60 * 1000;
  }

  function readState() {
    try {
      var raw = root.localStorage && root.localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (_err) {
      return null;
    }
  }

  function writeState(state) {
    try {
      if (root.localStorage) root.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
    } catch (_err) {
      log("localStorage write failed");
    }
  }

  function sessionExpired(state, now, timeoutMinutes) {
    var lastSeen = state && state.session && Date.parse(state.session.last_seen);
    if (!lastSeen) return true;
    return (now.getTime() - lastSeen) > timeoutMinutes * 60 * 1000;
  }

  function shouldCreateTouch(url, referrer, currentHost, state, now, options) {
    var params = parseAllowedParams(url);
    var refHost = referrerHost(referrer);
    var external = refHost && !isInternalReferrer(refHost, currentHost, options.extraInternalHosts);
    return hasAdvertisingParams(params) || external || sessionExpired(state, now, options.sessionTimeoutMinutes);
  }

  function transitionState(state, touch, now, options) {
    options = options || cfg();
    var next = state || { version: OA_VERSION, created_at: nowIso(now) };
    if (next.first && expired(next.first.ts, now, options.attributionWindowDays)) {
      next = { version: OA_VERSION, created_at: nowIso(now) };
    }
    next.version = OA_VERSION;
    next.updated_at = nowIso(now);
    next.session = next.session || {};
    next.paid_journey = bootstrapPaidJourney(next, now, options);
    var key = touchKey(touch);
    var sameInSession = next.session.touch_key && next.session.touch_key === key && !sessionExpired(next, now, options.sessionTimeoutMinutes);
    next.session.last_seen = nowIso(now);
    if (!touch || sameInSession) return next;
    next.session.touch_key = key;
    if (!next.first) next.first = touch;
    if (isPaid(touch) && !next.first_paid) next.first_paid = touch;
    next.last = touch;
    if (isPaid(touch)) {
      next.last_paid = touch;
      next.paid_journey.push(compactJourneyTouch(touch));
      next.paid_journey = normalizePaidJourney(next.paid_journey, now, options);
    }
    log(isPaid(touch) ? "new paid touch" : "new touch");
    return next;
  }

  function compact(value) {
    return String(value || "").substring(0, 500);
  }

  function buildCartAttributes(state) {
    var attrs = { _oa_version: OA_VERSION };
    ["first", "first_paid", "last", "last_paid"].forEach(function (name) {
      var touch = state && state[name];
      if (!touch) return;
      attrs["_oa_" + name + "_source"] = compact(touch.source);
      attrs["_oa_" + name + "_medium"] = compact(touch.medium);
      attrs["_oa_" + name + "_campaign_id"] = compact(touch.campaign_id);
      attrs["_oa_" + name + "_adset_id"] = compact(touch.adset_id);
      attrs["_oa_" + name + "_ad_id"] = compact(touch.ad_id);
      attrs["_oa_" + name + "_placement"] = compact(touch.placement);
      attrs["_oa_" + name + "_click_id"] = compact(touch.click_id);
      if (touch.click_id_type) attrs["_oa_" + name + "_" + touch.click_id_type] = compact(touch.click_id);
      attrs["_oa_" + name + "_ts"] = compact(touch.ts);
      attrs["_oa_" + name + "_landing_path"] = compact(touch.landing_path);
      attrs["_oa_" + name + "_referrer_host"] = compact(touch.referrer_host);
      attrs["_oa_" + name + "_classification"] = compact(touch.classification);
    });
    if (state && state.paid_journey && state.paid_journey.length) {
      attrs._oa_paid_journey = serializePaidJourney(state.paid_journey);
    }
    return attrs;
  }

  function mergeCartAttributes(existing, oaAttrs) {
    var merged = {};
    Object.keys(existing || {}).forEach(function (key) {
      if (key.indexOf("_oa_") !== 0) merged[key] = existing[key];
    });
    Object.keys(oaAttrs || {}).forEach(function (key) {
      merged[key] = oaAttrs[key];
    });
    return merged;
  }

  function cartRoot() {
    return root.Shopify && root.Shopify.routes && root.Shopify.routes.root ? root.Shopify.routes.root : "/";
  }

  function syncAttributionToCart(state) {
    if (!root.fetch || !state) return Promise.resolve(false);
    var oaAttrs = buildCartAttributes(state);
    return root.fetch(cartRoot() + "cart.js", { credentials: "same-origin" })
      .then(function (response) { return response.ok ? response.json() : { attributes: {} }; })
      .catch(function () { return { attributes: {} }; })
      .then(function (cart) {
        var attributes = mergeCartAttributes(cart.attributes || {}, oaAttrs);
        return root.fetch(cartRoot() + "cart/update.js", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ attributes: attributes })
        });
      })
      .then(function () { log("cart attribution synced"); return true; })
      .catch(function () { log("cart attribution sync failed"); return false; });
  }

  function loadPrivacy(callback) {
    if (!root.Shopify || !root.Shopify.loadFeatures) {
      callback();
      return;
    }
    root.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], function () { callback(); });
  }

  function canPersistMarketing() {
    var privacy = root.Shopify && root.Shopify.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== "function") return true;
    try { return privacy.marketingAllowed(); } catch (_err) { return false; }
  }

  function processPage() {
    var options = cfg();
    var now = new Date();
    var state = readState();
    var currentHost = root.location ? root.location.hostname : "";
    var referrer = root.document ? root.document.referrer : "";
    if (!shouldCreateTouch(root.location.href, referrer, currentHost, state, now, options)) {
      if (state && state.session) {
        state.session.last_seen = nowIso(now);
        writeState(state);
      }
      return;
    }
    var touch = buildTouch(root.location.href, referrer, currentHost, now);
    if (!canPersistMarketing()) {
      memoryTouch = touch;
      log("marketing consent not available; keeping touch in memory");
      return;
    }
    state = transitionState(state, touch, now, options);
    writeState(state);
    syncAttributionToCart(state);
  }

  function onConsentUpdate() {
    if (!memoryTouch || !canPersistMarketing()) return;
    var state = transitionState(readState(), memoryTouch, new Date(), cfg());
    writeState(state);
    memoryTouch = null;
    syncAttributionToCart(state);
  }

  function boot() {
    loadPrivacy(function () {
      processPage();
      if (root.document) root.document.addEventListener("visitorConsentCollected", onConsentUpdate);
    });
  }

  var api = {
    STORAGE_KEY: STORAGE_KEY,
    parseAllowedParams: parseAllowedParams,
    classify: classify,
    buildTouch: buildTouch,
    transitionState: transitionState,
    shouldCreateTouch: shouldCreateTouch,
    isInternalReferrer: isInternalReferrer,
    buildCartAttributes: buildCartAttributes,
    mergeCartAttributes: mergeCartAttributes,
    syncAttributionToCart: syncAttributionToCart,
    expired: expired,
    boot: boot
  };

  root.OAAttribution = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;
  if (root.document && root.location && root.location.href && !root.OA_ATTRIBUTION_DISABLE_AUTO_BOOT) boot();
})(typeof globalThis !== "undefined" ? globalThis : window);
